"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const bit_utils_common_1 = require("@gcloud-npm/bit.utils.common");
const bit_utils_constants_1 = require("@gcloud-npm/bit.utils.constants");
const cloudIsland_svg_1 = __importDefault(require("./cloudIsland.svg"));
const DESKTOP_WIDTH = 1920;
const DESKTOP_HEIGHT = 540;
const MOBILE_WIDTH = 1245;
const MOBILE_HEIGHT = 350;
const calculateBackgroundProps = () => {
    const currentDevice = (0, bit_utils_common_1.getDeviceKindDependsOnViewPort)();
    const screenWidth = window.innerWidth;
    let leftSize = (screenWidth - DESKTOP_WIDTH) / 2;
    let backgroundSize = `${DESKTOP_WIDTH}px ${DESKTOP_HEIGHT}px`;
    if (currentDevice === bit_utils_constants_1.DEVICES.MOBILE) {
        leftSize = (screenWidth - MOBILE_WIDTH) / 2;
        backgroundSize = `${MOBILE_WIDTH}px ${MOBILE_HEIGHT}px`;
    }
    if (leftSize > 0) {
        leftSize = 0;
    }
    const backgroundPosition = `${leftSize}px 0px`;
    const backgroundImage = `url(${cloudIsland_svg_1.default})`;
    return {
        backgroundPosition,
        backgroundSize,
        backgroundImage,
    };
};
class Beach extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = Object.assign({}, calculateBackgroundProps());
        this.setBackgroundProps = () => {
            const data = calculateBackgroundProps();
            this.setState(Object.assign({}, data));
        };
        this.componentWillUnmount = () => {
            window.removeEventListener('resize', this.setBackgroundProps);
        };
        this.componentDidMount = () => {
            window.addEventListener('resize', this.setBackgroundProps);
        };
    }
    render() {
        const { backgroundSize, backgroundPosition, backgroundImage } = this.state;
        return (react_1.default.createElement("div", { className: "BeachBackground", style: {
                backgroundImage,
                backgroundPosition,
                backgroundSize,
            } }));
    }
}
exports.default = Beach;
//# sourceMappingURL=Beach.js.map